import * as React from "react";
import { SubscribeToEvent } from "source/app/services/Events/Events";
import { EEventType } from "source/app/services/Events/EEventType";
import { LoadingSpinner } from "../../Calendar/LoadingSpinner";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";
import {
    LogWorkflowNavigation,
    ReportWorkflowNavigationIssue,
} from "source/app/services/Workflows/WorkflowNavigationDiagnostics";
import Hyperlink from "source/app/presentation/Shared/Link/Hyperlink";

export function WorkflowsLoadingIndicator() {
    const [showIndicator, setShowIndicator] = React.useState<boolean>(false);

    React.useEffect(() => {
        const unsubscribeStartLoading = SubscribeToEvent(
            EEventType.Workflows_RootNodeChange_StartLoading,
            () => {
                LogWorkflowNavigation("WorkflowsLoadingIndicator:show");
                setShowIndicator(true);
            }
        );

        const unsubscribeFinishLoading = SubscribeToEvent(
            EEventType.Workflows_RootNodeChange_FinishLoading,
            () => {
                LogWorkflowNavigation("WorkflowsLoadingIndicator:hide");
                setShowIndicator(false);
            }
        );

        return () => {
            unsubscribeStartLoading();
            unsubscribeFinishLoading();
        };
    }, []);

    if (!showIndicator) {
        return null;
    }

    return (
        <div>
            <LoadingSpinner
                className={StyleClassAuto({
                    textAlign: `left`,
                    marginTop: `10px`,
                })}
            />
            <div
                className={StyleClassAuto({
                    fontSize: `12px`,
                    marginTop: `4px`,
                    opacity: 0.8,
                })}
            >
                <Hyperlink
                    whenClicked={() =>
                        ReportWorkflowNavigationIssue(
                            "WorkflowsLoadingIndicator"
                        )
                    }
                >
                    report workflow spinner stuck
                </Hyperlink>
            </div>
        </div>
    );
}
